import React from 'react';
import T from 'prop-types';
import { isEmpty } from 'lodash-es';

import HeatmapTable, {
  HeatmapEmptyState,
  HeatmapTableSkeleton,
} from '../../../_shared/components/HeatmapTable';
import Tooltip from '../../../../../components/Tooltip';
import { initMaxDate } from '../../configs/chart-config';
import { formatValue } from '../../../_shared/utils/heatmap';

const emptyArray = [];

const sectorLeadHeader = (
  <div className="d-flex align-items-center justify-content-between">
    <div>Sector</div>
    <div className="d-flex">
      % of Time Spent{' '}
      <Tooltip
        content="Share of total mobile app time spent in each sector by this user segment"
        placement="top"
        colorVariant="light"
      >
        <span className="hicon-question-circle" />
      </Tooltip>
    </div>
  </div>
);

const renderSectorLeadCell = (sector) => (
  <td className="sector-lead-cell">
    <div className="sector-lead-cell__content">
      <div className="sector-lead-cell__name text-truncate">{sector.name}</div>
      <div className="sector-lead-cell__time-spent">{formatValue(sector.time_spent_pct)}</div>
    </div>
  </td>
);

const SectorsHeatmap = ({ months, data, isPending }) => {
  if (isPending) {
    return <HeatmapTableSkeleton height={640} />;
  }

  if (isEmpty(months) || isEmpty(data)) {
    return <HeatmapEmptyState />;
  }

  return (
    <HeatmapTable
      months={months || emptyArray}
      data={data || emptyArray}
      maxDate={initMaxDate}
      className="sectors-heatmap"
      leadHeader={sectorLeadHeader}
      getRowKey={(sector) => sector.name}
      renderLeadCell={renderSectorLeadCell}
    />
  );
};

SectorsHeatmap.propTypes = {
  months: T.arrayOf(T.string),
  data: T.arrayOf(
    T.shape({
      name: T.string,
      time_spent_pct: T.number,
      values: T.arrayOf(T.number),
    })
  ),
  isPending: T.bool.isRequired,
};

export default SectorsHeatmap;
